import { Injectable } from '@angular/core';

import { Http, Headers, /*Response*/ } from '@angular/http';
import { Observable } from 'rxjs/Observable';

import { ConfigService } from '../commons/config.service';
import { SessionService } from '../commons/session.service';
import { Param } from './models';

@Injectable()
export class WebsiteInterfaceService {

  constructor(
    private http: Http,
    private config: ConfigService,
    private session: SessionService) {
  }

  output(
    model: string,
    code: string,
    desc: string,
    params: Param[],
    isPackage: boolean): Observable<any> {

    return this.http.post(this.session.outputUrl + '/payment', {
      model: model,
      code: code,
      desc: desc,
      params: params.map(p => { return { key: p.name, value: p.selectedValue }; }),
      isPackage: isPackage,
      headers: this.getHeaders()
    }).map(res => {
      // mi aspetto l'url a cui fare redirect un redirect
      if (res.ok) {
        return res.text();
      } else {
        this.handleError({
          message: `Error in communication with website.
          Status code: ${res.status}. Status text: ${res.statusText}.
          Body: ${res.text()}`
        });
      }
    }).catch(err => this.handleError(err));
  }

  private getHeaders() {
    let headers = new Headers();
    headers.append('Accept', 'application/json');
    return headers;
  }

  /*private mapResponse(res: Response) {
    if (!res.ok) {
      this.handleError(res);
    } else {
      return res.json();
    }
  }*/

  private handleError(error: any) {
    let errMsg;

    if (!!error._body) {
      let errJson = JSON.parse(error._body);
      errMsg = (errJson.ExceptionMessage) ? errJson.ExceptionMessage : error._body;
    } else {
      errMsg = (error.message) ? error.message :
        error.status ? `${error.status} - ${error.statusText}` : 'Server error';
    }

    console.error(errMsg); // log to console instead
    return Observable.throw(errMsg);
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/commons/website-interface.service.ts